module.exports = __webpack_public_path__ + "202408221624/img/daxiao.63d1afee.png";